export const flowVersion = {
  formId: "create-flow-version",
  formField: {
    createNewVersion: {
      name: "create_new_version",
      label: "Version",
      type: "select",
      options: [
        { label: "Minor version", value: "minor_version" },
        { label: "New major version", value: "major_version" }
      ],
      placeholder: "",
      errorMsg: "Version type is required."
    }
  }
};
